import { render, staticRenderFns } from "./VendorsInfo.vue?vue&type=template&id=3f26f588&scoped=true&"
import script from "./VendorsInfo.vue?vue&type=script&lang=js&"
export * from "./VendorsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f26f588",
  null
  
)

export default component.exports